import request from '../utils/requests'
// 获取项目
export function getLiveList (params) {
  return request({
    url: '/live/ByHomeId',
    method: 'GET',
    params
  })
}
// 获取直播间信息
export function getLiveInfo (params, id) {
  return request({
    url: `/live/info/${id}`,
    method: 'GET',
    params
  })
}
// 获取项目下所有直播间
export function getAllLiveInfo (data) {
  return request({
    url: `/live/user/list`,
    method: 'POST',
    data
  })
}
// 获取pv
export function getPv (params, id) {
  return request({
    url: `/live/log/getLive/${id}`,
    method: 'GET',
    params
  })
}
// 点击量增加
export function addPv (params, id) {
  return request({
    url: `/live/log/pv${id}`,
    method: 'GET',
    params
  })
}
// 获取微信配置
export function shareConfig (params) {
  return request({
    url: `/wx/user/share`,
    method: 'GET',
    params
  })
}
// 点赞
export function addGoodUp (params) {
  return request({
    url: `/live/livePraise`,
    method: 'GET',
    params
  })
}
